import { useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import {
  DataTable,
  GridButton,
  PageHeader,
  InputTypeConstants,
  SearchParamTypeConstants,
  getSearchField,
  getTableHeader,
} from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../Constants";
import { UserService } from "../../Services";
import UserContext from "../../Contexts/UserContext";

function UserList() {
  const navigate = useNavigate();
  const dataTableRef = useRef();
  const { user } = useContext(UserContext);

  function getActionButtons(value) {
    return (
      <>
        <GridButton
          id={"btnEdit" + value.id}
          color="btn-primary"
          icon={faPencil}
          disabled={value.deleted}
          ariaLabel="Edycja użytkownika"
          title="Edycja użytkownika"
          onClick={() => console.log("edycja")}
        />
      </>
    );
  }

  function fetchUser() {
    return [user];
  }

  const searchFields = [
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "email",
      "E-mail",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "firstName",
      "Imię",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "lastName",
      "Nazwisko",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_EQUAL,
      "deleted",
      "Pokaż usunięte",
      InputTypeConstants.checkbox
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_EQUAL,
      "isNewest",
      "Czy profil jest najnowszy",
      InputTypeConstants.string,
      null,
      true.toString(),
      true
    ),
  ];

  const tableHeaders = [
    getTableHeader("E-mail", "email", null, true, "w-25"),
    getTableHeader("Imię", "firstName", null, true, "w-15"),
    getTableHeader("Nazwisko", "lastName", null, true, "w-15"),
    getTableHeader(
      null,
      null,
      "Akcje",
      false,
      "w-10",
      getActionButtons,
      "text-center"
    ),
  ];

  const getRowProps = (value) => ({
    className: value.deleted ? "row-deleted" : "",
  });

  return (
    <>
      <PageHeader content={PageTitleConstants.UserList} />
      <Card>
        <Card.Body className="pt-4-5">
          <DataTable
            fetchData={fetchUser}
            headers={tableHeaders}
            searchFields={searchFields}
            rowProps={getRowProps}
            ref={dataTableRef}
          >
            <Button variant="primary" onClick={() => {}}>
              Dodaj użytkownika
            </Button>
          </DataTable>
        </Card.Body>
      </Card>
    </>
  );
}

export default UserList;
